export default __webpack_public_path__ + "static/media/5.3283b398.png";